<template>
  <ComponentLayout id="new-tender-terms-step">
    <template #breadcrumbs>
      <TenderBreadcrumbs
        :dialog.sync="isDialog"/>
    </template>
    <template #main_content>
      <StepsInfo/>
      <div class="width-100 mt-2 mb-8 h1-headline text-left">
        Оберіть потрібні дії
      </div>
      <div
        class="width-65 px-6 py-4 main__light_green radius-8 text-left">
        <div
          v-if="copyQualifiedBidsToAuction">
          <div class="h4-headline pb-3">
            Скопіювати всі кваліфіковані пропозиції
          </div>
          <div class="secondary__green_not_active--text">
            {{ $t('Tenders.copyQualifiedBidsToAuctionHint') }}
          </div>
          <RadioGroup
            class-name="mt-0 py-0"
            data-qa="prolog"
            :model.sync="copyAllBids"/>
        </div>

        <div
          v-if="labelSetStepAndOtherCheck"
          :class="{'mt-6': copyQualifiedBidsToAuction}">
          <div class="h4-headline pb-3">
            {{ labelSetStepAndOtherCheck }}
          </div>
          <div class="secondary__green_not_active--text"/>
          <RadioGroup
            class-name="mt-0 py-0"
            data-qa="prolog"
            :model.sync="setStepAndOther"/>
        </div>
      </div>
    </template>
    <template #footer>
      <CreateTenderFooter
        key="footer"
        :back="cancel"
        :back_btn="!auction || $t('Common.Cancel')"
        :check_disable="$_minTenderPeriodDate"
        :next="beforeNextStep"
        next_btn
        :publish.sync="isDialog"/>
    </template>
  </ComponentLayout>
</template>
<script>
import StepsInfo from 'components/tenders/StepsInfo.vue'
import RadioGroup from 'components/common/inputs/RadioGroup.vue'
import ComponentLayout from 'pages/templates/ComponentLayout.vue'
import TenderBreadcrumbs from 'components/tenders/TenderBreadcrumbs.vue'
import CreateTenderFooter from 'components/tenders/CreateTenderFooter.vue'

import { mapGetters } from 'vuex'

import { tenderMixin, storageMixin } from 'mixins'

export default {
  name: 'WeRecommendTender',
  mixins: [ tenderMixin, storageMixin, ],
  data() {
    return {
      copyAllBids: true,
      setStepAndOther: true,
    }
  },
  methods: {
    cancel() {
      this.$emit('update:auction', false)
    },
    beforeNextStep() {
      if (this.copyQualifiedBidsToAuction) {
        this.$_savePropToLocalStorage(`copyAllBids_${this.tender.tenderId}`, this.copyAllBids ? 1 : 0, true)
      }

      let nextStep = 3

      if (this.labelSetStepAndOtherCheck && this.setStepAndOther) {
        nextStep = 2
      }
      this.$store.commit('setNewTenderInfo', {...this.info, step: nextStep })
    },
  },
  computed: {
    ...mapGetters({
      tender: 'getNewTender',
      info: 'getNewTenderInfo'
    }),
    labelSetStepAndOtherCheck() {
      let label = ''
      if (this.isRowMinStepPercent || this.isRowInitialAmount) {
        label += 'Вказати'
      }
      if (this.isRowMinStepPercent) {
        label += ` початкову ставку${this.isRowInitialAmount ? ' i' : ''}`
      }
      if (this.isRowInitialAmount) {
        label += ' крок торгів'
      }
      return label
    },
    isDialog: {
      get() {
        return this.auction
      },
      set(newValue) {
        this.$emit('update:auction', newValue)
      }
    },
  },
  components: {
    StepsInfo,
    RadioGroup,
    ComponentLayout,
    TenderBreadcrumbs,
    CreateTenderFooter
  },
  created() {
    this.copyAllBids = !!this.$_getPropFromLocalStorage(`copyAllBids_${this.tender.tenderId}`, 1, true)
    if (!this.copyQualifiedBidsToAuction && !this.labelSetStepAndOtherCheck) {
      this.$store.commit('setNewTenderInfo', {...this.info, step: this.info.step + 1 })
    }
  },
  props: {
    auction: Boolean,
    copyQualifiedBidsToAuction: Boolean,
    isRowMinStepPercent: Boolean,
    isRowInitialAmount: Boolean
  },
}
</script>
